import { DATE_FORMATS } from '@constants/date.ts';
import { useAppSelector } from '@hooks/reduxHooks.ts';
import { useLingui as useMacroLingui } from '@lingui/react/macro';
import { formatDateBasedOnPreferences } from '@utils/date.ts';

import { BlueByteLogoWrapper, FooterLogoWrapper, PoweredBy, Version } from './styled.tsx';

const FooterLogo = () => {
    const { t } = useMacroLingui();
    const healthStatus = useAppSelector((state) => state.health.healthStatus);
    const buildTimeUTC = healthStatus?.buildTimeUTC
        ? formatDateBasedOnPreferences(healthStatus?.buildTimeUTC, DATE_FORMATS.EUROPEAN_DASH)
        : '';
    const deployedAtUTC = healthStatus?.buildTimeUTC
        ? formatDateBasedOnPreferences(healthStatus?.deployedAtUTC, DATE_FORMATS.EUROPEAN_DASH)
        : '';
    return (
        <FooterLogoWrapper id="footer-logo">
            <PoweredBy>{t`Powered by`}</PoweredBy>
            <BlueByteLogoWrapper />
            <Version>
                {t`Built on:`} <strong>{buildTimeUTC}</strong> {t`Deployed on:`} <strong>{deployedAtUTC}</strong>
            </Version>
        </FooterLogoWrapper>
    );
};
export default FooterLogo;
